import { FormControlLabel, Radio, Typography, useTheme } from "@mui/material";

const UIRadioButton = (props) => {
    const {
        loading = false,
        checked = false,
        label = '',
        value = '',
        disabled = false,
        outlined = false,
        name = '',
        width = false,
        onChange = new Function
    } = props;

    const theme = useTheme()

    return (
        <>
            <div width={'100%'} className={`${outlined ? 'checkbox-outlined' : ''} ${ width ? width : 'd-inline-block'} py-0 px-2`} >
                <FormControlLabel
                    key={value}
                    value={value}
                    name={name}
                    onChange={(e) => {
                        onChange(e?.target?.value)
                    }}
                    control={<Radio checked={checked} disabled={disabled} />}
                    label={
                        <Typography variant="body1" sx={{fontSize:'14.5px', fontWeight:'500', opacity: disabled ? theme.palette.mode === 'dark' ? 0.5 : 0.7 : 1, }}>
                            {label}
                        </Typography>
                    }
                />
            </div>
        </>
    );
};

export { UIRadioButton };